import React from "react"
import {AssigneeAvatarWithName} from "../AssigneeAvatarWithName/AssigneeAvatarWithName"
import {AssignmentItemStatus} from "../AssignmentItemStatus/AssignmentItemStatus"
import {Assignee, AssignmentStatus} from "../../resources/assignments"
interface AssignmentPageItemHeaderProps {
	assignees: Assignee[]
	status: AssignmentStatus
	escalatedBadge?: React.ReactNode
}

export function AssignmentPageItemHeader({assignees, status, escalatedBadge}: AssignmentPageItemHeaderProps) {
	return (
		<section>
			<div className="assignment-page-item-header-assignee-and-status-container">
				<AssigneeAvatarWithName assignees={assignees} size="small" />
				<AssignmentItemStatus status={status} />
				{escalatedBadge}
			</div>
		</section>
	)
}
